// extracted by mini-css-extract-plugin
export default {"container":"Roadmap_container__8K1y9","roadmap":"Roadmap_roadmap__xmhyX","card":"Roadmap_card__q680j","image":"Roadmap_image__gEp6m"};